import { fetchFluxBotAction } from "@/api/endpoints/fluxbot";

export async function createFluxBotSwap({
	wallet,
	inMint,
	outMint,
	inAmount,
}: {
	wallet: string;
	inMint: string;
	outMint: string;
	inAmount: number;
}): Promise<any> {
	// Validate that source and destination tokens are different
	if (inMint === outMint) {
		throw new Error("Cannot swap a token for itself. Source and destination must be different tokens.");
	}
	const response = await fetchFluxBotAction(wallet, "swap", {
		source: inMint,
		dest: outMint,
		aToB: true,
		amount: Number(inAmount),
	});

	// Validate the response before returning it
	if (!response || response.error) {
		throw new Error(response.error || "Failed to create swap: Empty response");
	}

	// If we have a signature or transaction, return the response
	if (response.signature || response.transaction) {
		return response;
	}

	// If we don't have a signature or transaction, throw an error
	throw new Error("Failed to create swap: Invalid response format");
}
